import { Checkbox } from '@mui/material';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { ArrayElement, BaseTableConfiguration } from '@/__configs/config_types';
import { selectRowItem } from '@/redux/slices/dataTableSlice';
import { selectCheckedTableRows, selectCurrentTableBulkActionsByStatusStage } from '@/redux/selectors/dataTableSelectors';

type TableRowCheckboxProps = {
  data?: ArrayElement<BaseTableConfiguration<unknown, unknown>['selected']>;
};

const TableRowCheckbox = ({ data }: TableRowCheckboxProps) => {
  const dispatch = useAppDispatch();
  const selectedRows = useAppSelector(selectCheckedTableRows);
  const selectActions = useAppSelector(selectCurrentTableBulkActionsByStatusStage);
  const isChecked = Boolean(selectedRows.find((row: typeof data) => row?.id === data?.id));
  const enabled = selectActions && data ? selectActions[data?.status]?.actions.length || selectActions[data?.status]?.stage[data?.stage]?.length : false;

  const handleChange = (_: any, checked: boolean) => {
    dispatch(selectRowItem({ selected: data, checked }));
  };

  return (
    <Checkbox
      disabled={!enabled}
      sx={{ opacity: !enabled ? 0.4 : 1 }}
      checked={isChecked}
      onClick={(e) => e.stopPropagation()}
      onChange={handleChange}
    />
  );
};

export default TableRowCheckbox;
